import { computedFrom } from 'aurelia-binding';
import { HttpClient } from 'aurelia-fetch-client';
import { autoinject } from 'aurelia-framework';
import 'whatwg-fetch';
import { ApiResponse } from '../models/api-response';
import { Offer } from '../models/offer';
import { State } from './global-state';
import { HPFServiceClient } from './hpfApi';

@autoinject
export class HpfCustomerService extends HPFServiceClient {

	constructor(
		state: State,
		http: HttpClient,
	) {
		super(state, http);
	}

	makeOffer(accountKey, frequency, amount) {
		let url = `/customerAccounts/${accountKey}/offer`;
		let content = {
			frequency,
			amount
		};

		return this.post(url, content).then((result) => {
			if (result.isSuccessful) {
				return result.value as MakeOfferResponse;
			} else {
				return null;
			}
		});
	}

	logOfferSelected(sessionId, selectedOfferType: number) {
		let url = `/negotiatorActivities/${sessionId}`;
		let content = {
			selectedOfferType
		};

		return this.post(url, content).then((result) => {
			if (result.isSuccessful) {
				return result.value;
			} else {
				return null;
			}
		});

	}

	sendContactMeRequest(customerAccountKey: number, consumerName: string, consumerEmail: string, consumerPhoneNumber: string, requiresAssistedCall: boolean) {
		let url = `/customerAccounts/${customerAccountKey}/consumerContact`;
		let content = {
			customerAccountKey,
			consumerName,
			consumerEmail,
			consumerPhoneNumber,
			requiresAssistedCall
		};

		return this.post(url, content).then((result) => {
			if (result.isSuccessful) {
				return result.value as MakeOfferResponse;
			} else {
				return null;
			}
		});
	}

}


export class MakeOfferResponse {
	accepted: boolean;
	counterOffer: Offer;
	acceptedOffer: Offer;
	negotiatorActivitySessionId: string;
}
